import { render, staticRenderFns } from "./LocatorAssigned.vue?vue&type=template&id=63d16bc9&scoped=true&"
import script from "./LocatorAssigned.vue?vue&type=script&lang=js&"
export * from "./LocatorAssigned.vue?vue&type=script&lang=js&"
import style0 from "./LocatorAssigned.vue?vue&type=style&index=0&id=63d16bc9&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d16bc9",
  null
  
)

export default component.exports